import api from './axiosConfig';

/** 管理画面で選択できる解析モデル（config の selectable_models を ai_models で装飾したもの） */
export interface AiAnalysisAvailableModel {
  value: string;
  label: string;
  description: string | null;
  /** 1kトークンあたりの入力単価（USD）。$/1M 表示に使うため 1000 倍する */
  input_per_1k: number | null;
  output_per_1k: number | null;
}

/** 解析タスク1件の現在の状態 */
export interface AiAnalysisTaskRow {
  key: string;
  label: string;
  /** config でモデルを固定しているタスクはその値。基本モデルに従うタスクは null */
  pinned_model: string | null;
  /** 管理画面から保存されたタスク別上書き */
  override_model: string | null;
  /** サーバーが解決した実際に使われるモデル */
  effective_model: string | null;
  reasoning_effort: string | null;
  max_output_tokens: number | null;
}

/** DBに保存されている設定（1行） */
export interface AiAnalysisModelSetting {
  default_model: string | null;
  task_models: Record<string, string>;
  updated_at: string | null;
  updated_by_admin_id: number | null;
}

export interface AiAnalysisModelSettingData {
  /** AI_ANALYSIS_ROUTING_ENABLED。false ならこの設定は使われない */
  routing_enabled: boolean;
  config_default_model: string;
  effective_default_model: string;
  setting: AiAnalysisModelSetting;
  available_models: AiAnalysisAvailableModel[];
  tasks: AiAnalysisTaskRow[];
}

export interface AiAnalysisModelSettingResponse {
  success: boolean;
  data: AiAnalysisModelSettingData;
}

/** PUT のペイロード。null は「既定に戻す」「上書きを削除」の意味 */
export interface AiAnalysisModelUpdatePayload {
  default_model: string | null;
  task_models: Record<string, string | null>;
}

const adminAiAnalysisModelService = {
  async get(): Promise<AiAnalysisModelSettingResponse> {
    const response = await api.get<AiAnalysisModelSettingResponse>('/admin/ai-analysis-models');
    return response.data;
  },

  async update(payload: AiAnalysisModelUpdatePayload): Promise<AiAnalysisModelSettingResponse> {
    const response = await api.put<AiAnalysisModelSettingResponse>('/admin/ai-analysis-models', payload);
    return response.data;
  },
};

export default adminAiAnalysisModelService;
